import * as React from 'react';

import { EmptyField, TextField } from '../../../../../../components/Field/common';
import { useOfferContext } from '../../../../../../utils/offerContext';

export const WindowViewContainer: React.FC = () => {
  const { windowsView, published } = useOfferContext();

  if (!windowsView) {
    return <EmptyField published={published} />;
  }

  return <TextField published={published}>{windowsView}</TextField>;
};
